const CARD_SELECTOR = '[data-masonry-card]';
const TOGGLE_SELECTOR = '[data-masonry-card-toggle]';
const WRAP_SELECTOR = '.masonry-card__details-wrap';
const INNER_SELECTOR = '.masonry-card__details-inner';

/** Zgodne z Tailwind `lg` (1024px). */
const mqMobile = window.matchMedia('(max-width: 1023px)');
const mqReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function getDetailsEls(card) {
    const wrap = card.querySelector(WRAP_SELECTOR);
    const inner = card.querySelector(INNER_SELECTOR);
    return { wrap, inner };
}

function shouldDetailsBeOpen(card) {
    if (mqMobile.matches) {
        return card.classList.contains('is-expanded');
    }
    return card.hasAttribute('data-masonry-details-open');
}

/**
 * Animacja wysokości 0 ↔ dokładny scrollHeight (px), potem auto przy otwarciu.
 * Nadal to jest layout (nie transform na GPU), ale krótka droga = zwykle płynniej niż max-height do stałego sufitu.
 */
function updateDetailsHeight(card) {
    const { wrap, inner } = getDetailsEls(card);
    if (!wrap || !inner) {
        return;
    }

    const open = shouldDetailsBeOpen(card);

    if (mqReduceMotion.matches) {
        if (open) {
            wrap.style.height = 'auto';
        } else {
            wrap.style.height = '0px';
        }
        return;
    }

    if (open) {
        const target = inner.scrollHeight;
        wrap.style.height = '0px';
        void wrap.offsetHeight;
        requestAnimationFrame(() => {
            wrap.style.height = `${target}px`;
        });

        const onEnd = (ev) => {
            if (ev.propertyName !== 'height') {
                return;
            }
            if (shouldDetailsBeOpen(card)) {
                wrap.style.height = 'auto';
            }
        };
        wrap.addEventListener('transitionend', onEnd, { once: true });
    } else {
        const h = inner.scrollHeight;
        if (h <= 0) {
            wrap.style.height = '0px';
            return;
        }
        if (wrap.style.height === 'auto' || !wrap.style.height) {
            wrap.style.height = `${h}px`;
        }
        void wrap.offsetHeight;
        requestAnimationFrame(() => {
            wrap.style.height = '0px';
        });
    }
}

function closeAllMasonryCards() {
    document.querySelectorAll(`${CARD_SELECTOR}.is-expanded`).forEach((card) => {
        card.classList.remove('is-expanded');
        const toggle = card.querySelector(TOGGLE_SELECTOR);
        if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
        }
        updateDetailsHeight(card);
    });
}

function toggleCard(card) {
    const toggle = card.querySelector(TOGGLE_SELECTOR);
    if (!toggle) {
        return;
    }
    const wasExpanded = card.classList.contains('is-expanded');
    closeAllMasonryCards();
    if (!wasExpanded) {
        card.classList.add('is-expanded');
        toggle.setAttribute('aria-expanded', 'true');
        updateDetailsHeight(card);
    }
}

function isInteractiveNonToggleTarget(target) {
    if (!(target instanceof Element)) {
        return false;
    }
    if (target.closest('a[href]')) {
        return true;
    }
    return false;
}

export function initMasonryExpandableCards() {
    const cards = document.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) {
        return;
    }

    cards.forEach((card) => {
        const toggle = card.querySelector(TOGGLE_SELECTOR);
        if (!toggle) {
            return;
        }

        card.addEventListener('click', (e) => {
            if (!mqMobile.matches) {
                return;
            }
            if (isInteractiveNonToggleTarget(e.target)) {
                return;
            }
            toggleCard(card);
        });

        card.addEventListener('mouseenter', () => {
            if (mqMobile.matches) {
                return;
            }
            card.setAttribute('data-masonry-details-open', '1');
            updateDetailsHeight(card);
        });
        card.addEventListener('mouseleave', () => {
            if (mqMobile.matches) {
                return;
            }
            card.removeAttribute('data-masonry-details-open');
            updateDetailsHeight(card);
        });
    });

    document.addEventListener('click', (e) => {
        if (!e.target.closest(CARD_SELECTOR)) {
            closeAllMasonryCards();
        }
    });

    mqMobile.addEventListener('change', () => {
        if (!mqMobile.matches) {
            closeAllMasonryCards();
        } else {
            document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
                card.removeAttribute('data-masonry-details-open');
                updateDetailsHeight(card);
            });
        }
    });
}
